import { HTMLAttributes } from 'react';
import { ClickableTextTypes } from '../../components/clickableText/ClickableTextTypes';
import { LocationTypes } from '../sitewide';
import { IconTypes } from '../../utilities/icomoon-css/iconTypes';

export namespace ContactUsPageTypes {
  export type TColorType = 'primary' | 'secondary' | string;
  export type TReachUsComponentTypes = {
    linkType?: ClickableTextTypes.TLinkType;
    data: TReachUsTypes[];
    title?: string;
    allIconsColor?: string;
    addressDetails?: {
      gMapDetails: LocationTypes.TGMapLocation;
      googleMapPlaceId: string;
    };
  };
  export type TReachUsTypes = TAddress | TEmailAddress | TContactNumber;
  export type TIconSection = {
    iconClassName: IconTypes.TName;
    size?: string | number;
    color?: TColorType;
  };
  export type TIconConfig = {
    iconClassName: IconTypes.TName;
    color?: TColorType;
    size?: number | string;
  };
  export type TNewIcon = {
    icon: TIconConfig;
    iconsUrl: string;
    locationName: string;
  };
  export type TSocialIcons = {
    twitterIcon?: TNewIcon[];
    facebookIcon?: TNewIcon[];
    linkedInIcon?: TNewIcon[];
    instagramIcon?: TNewIcon[];
    whatsAppIcon?: TNewIcon[];
  };
  export type TAddress = {
    icon?: TIconSection;
    label?: string;
    data: string;
    link: string;
  };
  export type TContactNumber = {
    icon?: TIconSection;
    label?: string;
    data?: string;
    link?: string;
  };
  export type TEmailAddress = {
    icon: TIconSection;
    label?: string;
    data: string;
    link: string;
  };
  export type TLocationType = 'single' | 'multi';
  export interface IFacilityHrs extends HTMLAttributes<HTMLDivElement> {
    show: boolean;
    locationConfig: LocationTypes.ILocationMap;
    isHoursForAllLocationsSame?: boolean;
    showIcons?: boolean;
    locationType: TLocationType;
  }
  export type TContactDetails = {
    facilityName?: string;
    locationName?: string;
    facilityAddress?: TAddress[];
    mailingAddress?: TAddress[];
    contactNumber?: TContactNumber[];
    emailAddress: TEmailAddress[];
    facilityGateHours?: IFacilityHrs;
    socialIcons?: TSocialIcons;
    backgroundImgURL?: String;
    contactUsFormHeading?: String;
  };

  export type TVariant = 'newContactUsLightTheme' | 'newContactUsDarkTheme';
  export interface IContactUsPage extends HTMLAttributes<HTMLDivElement> {
    variant: TVariant;
    contactDetails: TContactDetails;
  }
  export interface TClickableDiv extends HTMLAttributes<HTMLButtonElement> {
    url?: string;
    type: ClickableTextTypes.TLinkType;
    addressDetails?: {
      gMapDetails: LocationTypes.TGMapLocation;
      googleMapPlaceId: string;
    };
    allIconsColor?: string;
    text: string;
    onCustom?: () => string | void;
    children: JSX.Element | JSX.Element[];
  }
}
